import React, { useState, useEffect } from "react";
import { getOS } from "../../ultil";
import { connect } from "react-redux";
import Modal from "react-modal";
import HeyUDownload from "./HeyUDownload";
import InputCustom from "../Input/InputCustom";
import TextTitle from "../Text/TextTitle";
import TextTitle1 from "../Text/TextTitle1";
import TextBody from "../Text/TextBody";
import TextBody2 from "../Text/TextBody2";
import TextHead from "../Text/TextHead";
import TextPrice from "../Text/TextPrice";
import TextPriceOld from "../Text/TextPriceOld";
import TextQuantity from "../Text/TextQuantity";
import TextOutOfStock from "../Text/TextOutOfStock";
import { modalStyleBottom, modalStyleDetail, modalStyleCenter, style } from "../../style";
import { useTheme, styled } from '@mui/material/styles';
import {
  Avatar,
  AppBar,
  Box,
  Divider,
  IconButton,
  Button,
  ButtonBase,
  ButtonGroup,
  Toolbar,
  Tab,
  Tabs,
  Slide,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Grid,
  Stack,
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LogoutIcon from '@mui/icons-material/Logout';
function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
}

const AccountUser = ({
  user,
  btnLogout,
  btnLoginScreen,
  platform,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const btnOpenQrcode = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  return (
    <>
    <Box sx={{ position: 'relative', bgcolor: '#f0f0f0', height: '100%', display: 'flex',flexDirection: 'column'}}>
      <AppBar
        position="sticky"
        color="inherit"
      >
        <Toolbar sx={{minHeight: '52px'}}>
          <TextTitle1 sx={{flexGrow: 1, textAlign: 'center'}} variant="h5" component="div">
            Tài khoản
          </TextTitle1>
          {
            !_.isEmpty(user) &&
            <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={btnLogout}
            sx={{position: 'absolute', right: 0}}
            >
            <LogoutIcon sx={{fontSize: '24px'}}/>
            </IconButton>
          }
        </Toolbar>
      </AppBar>
      <Box display="flex" flexDirection="column" justifyContent="start" position="relative" bgcolor='#FFFFFF' flexGrow={1} mt={1} p={3}>
        <Stack direction="column" justifyContent="center" alignItems="center">
          <Avatar
            alt={_.get(user, 'facebook.name')}
            src={_.get(user, 'facebook.picture')}
            sx={{ width: '64px', height: '64px' }}
          />
          {
            !_.isEmpty(user)?
            <>
            <TextTitle mt={2}>{_.get(user, 'facebook.name')}</TextTitle>
            <TextBody2 mt={1} color="#929394">Số điện thoại: {_.get(user, 'phone')}</TextBody2>
            <TextBody2 color="#929394">Mã thành viên: {_.get(user, 'code')}</TextBody2>
            </>
            :
            <TextBody mt={2} color="#929394">Bạn cần đăng nhập để xem nội dung này</TextBody>

          }
        </Stack>
      </Box>
      <Box sx={{position: 'static', width: '100%', maxWidth: '600px', bottom: 0, zIndex: 1, bgcolor: '#ffffff', boxShadow: '0px -2px 8px rgba(92, 83, 83, 0.08)'}}>
      <HeyUDownload platform={platform}/>
      {
        _.isEmpty(user)?
        <Box sx={{width: '100%', padding: '8px 16px'}}>
          <Button onClick={btnLoginScreen} fullWidth size="large" variant="contained" sx={{borderRadius: '16px', fontSize: '16px', textTransform: 'none', bgcolor: '#1589D8'}}>
            Đăng nhập
          </Button>
        </Box>
        :null
      }
      </Box>
    </Box>
    </>
  );
}

const mapStateToProps = state => state;
const mapFunctionToProps = {
  // getUserInf,
  // setGlobalVariable,
};
export default connect(mapStateToProps, mapFunctionToProps)(AccountUser);
